// client/src/pages/Game/Battlefield/components/BattlefieldCardPreview.jsx
// Utilise le canvas universel CardModal (meme rendu que la collection)
// + bouton d'activation pour les capacites manuelles (trigger MANUAL /
// ONCE_PER_TURN / type ACTIVE) quand c'est notre tour et notre carte.
import React from 'react';
import CardModal from '../../../../components/cards/CardModal';

export const getActivatableAbilities = (card) =>
  (card?.effects || []).filter(eff =>
    eff && (eff.trigger === 'MANUAL' || eff.trigger === 'ONCE_PER_TURN' || eff.type === 'ACTIVE')
  );

const BattlefieldCardPreview = ({ card, onClose, getCardElement, onActivateAbility, canActivate }) => {
  if (!card) return null;

  const abilities = getActivatableAbilities(card);
  const showActivate = onActivateAbility && canActivate && abilities.length > 0;

  const footer = showActivate ? (
    <button
      className="cm-activate-btn"
      onClick={() => onActivateAbility(card, 0, abilities[0])}
    >
      ⚡ Activer l'effet
    </button>
  ) : null;

  return <CardModal card={card} onClose={onClose} footer={footer} />;
};

export default BattlefieldCardPreview;
